import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HomePage() {
  const [showContinueButton, setShowContinueButton] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Timer de 25 segundos após o carregamento da página
    const timer = setTimeout(() => {
      setShowContinueButton(true);
    }, 25000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const handleContinue = () => {
    navigate('/estrategia');
  };

  return (
    <div className="min-h-screen bg-[#F8F6F3]">
      {/* Navegação Superior */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#2C3539]/95 backdrop-blur-sm shadow-sm transition-all duration-300">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <img 
            src="https://static.readdy.ai/image/8e1dd29798fcb43b2566dc879e04c9bd/eaa29081c8576d56531a963372a22dd6.png" 
            alt="Lilian Poli - Estratégia Patrimonial" 
            className="h-12 w-auto object-contain"
          />
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6 min-h-screen flex items-center">
        <div className="max-w-5xl mx-auto text-center w-full">
          {/* Headline Principal */}
          <h1 className="text-5xl md:text-6xl font-serif text-[#2C3539] leading-tight mb-6 font-bold">
            Como Transformar Crédito em Alavancagem<br />
            <span className="italic text-[#B8935E]">Sem Depender de Juros Abusivos</span>
          </h1>
          
          <div className="flex justify-center mb-12">
            <div className="w-20 h-0.5 bg-[#B8935E]"></div>
          </div>

          <p className="text-xl text-[#2C3539]/80 mb-16 max-w-3xl mx-auto leading-relaxed">
            A estratégia que empresários e famílias de alto patrimônio estão usando para proteger o caixa e construir legado de forma disciplinada
          </p>

          {/* Container do Vídeo do YouTube */}
          <div className="max-w-4xl mx-auto">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-black" style={{ paddingBottom: '56.25%', height: 0 }}>
              <iframe 
                className="absolute top-0 left-0 w-full h-full"
                src="https://www.youtube.com/embed/dK3TlyTGaLo?enablejsapi=1&rel=0&modestbranding=1&autoplay=1&mute=1&origin=https://readdy.ai"
                title="Estratégia Patrimonial - Lilian Poli"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          {/* Botão Continuar - Aparece após 25 segundos */}
          <div className={`mt-16 transition-all duration-1000 ${showContinueButton ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'}`}>
            <button 
              onClick={handleContinue}
              className="group inline-flex items-center gap-3 bg-[#B8935E] hover:bg-[#C9A46F] text-[#2C3539] font-bold text-lg px-12 py-5 rounded-full transition-all duration-300 shadow-2xl hover:shadow-[#B8935E]/50 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <span className="uppercase tracking-wide">Continuar</span>
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
            </button>
          </div>
        </div>
      </section>

      {/* Rodapé Minimalista */}
      <footer className="bg-[#1A1A1A] py-8 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <img 
            src="https://static.readdy.ai/image/8e1dd29798fcb43b2566dc879e04c9bd/eaa29081c8576d56531a963372a22dd6.png" 
            alt="Lilian Poli" 
            className="h-10 w-auto object-contain mx-auto mb-4 opacity-80"
          />
          <p className="text-sm text-gray-500">
            © 2025 Lilian Poli - Estratégia Patrimonial. Todos os direitos reservados.
          </p>
        </div>
      </footer>
    </div>
  );
}
